import { useState } from "react";
import { toast } from "sonner";
import { Trash2, Pencil } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { api, errMsg } from "@/lib/api";
import { Loading } from "@/components/RequireAuth";
import { CategoryIcon } from "@/components/CategoryIcon";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const EMPTY = { name: "", slug: "", icon: "Tag", subcategories: "", order: 99 };

export default function AdminCategories() {
  const { data, reload } = useApi("/categories");
  const [f, setF] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const save = async () => {
    const body = { ...f, order: Number(f.order) || 99, subcategories: f.subcategories.split(",").map((s) => s.trim()).filter(Boolean) };
    try {
      if (editId) await api.put(`/admin/categories/${editId}`, body);
      else await api.post("/admin/categories", body);
      toast.success("Catégorie enregistrée");
      setF(EMPTY); setEditId(null); reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (c) => {
    if (!window.confirm(`Supprimer « ${c.name} » ?`)) return;
    try { await api.delete(`/admin/categories/${c.id}`); toast.success("Catégorie supprimée"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="admin-categories" className="space-y-5">
      <h1 className="font-display text-3xl font-black tracking-tight">Catégories</h1>
      <div className="grid gap-2 rounded-xl border bg-white p-4 sm:grid-cols-[1fr_1fr_2fr_auto]">
        <Input data-testid="cat-name" placeholder="Nom" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <Input data-testid="cat-slug" placeholder="slug (ex : sport)" value={f.slug} onChange={(e) => setF({ ...f, slug: e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "") })} />
        <Input data-testid="cat-subs" placeholder="Sous-catégories, séparées par des virgules" value={f.subcategories} onChange={(e) => setF({ ...f, subcategories: e.target.value })} />
        <Button onClick={save} data-testid="cat-save">{editId ? "Modifier" : "Ajouter"}</Button>
      </div>
      {!data ? <Loading /> : (
        <div className="divide-y rounded-xl border bg-white">
          {data.map((c) => (
            <div key={c.id} data-testid={`admin-cat-${c.slug}`} className="flex items-center gap-3 p-3 text-sm">
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-orange-100 text-orange-600"><CategoryIcon name={c.icon} className="h-4 w-4" /></span>
              <div className="flex-1"><p className="font-semibold">{c.name} <span className="text-gray-400">/{c.slug}</span></p><p className="text-gray-500">{c.subcategories.join(", ")}</p></div>
              <Button size="icon" variant="ghost" data-testid={`cat-edit-${c.slug}`} onClick={() => { setEditId(c.id); setF({ ...c, subcategories: c.subcategories.join(", ") }); }}><Pencil className="h-4 w-4" /></Button>
              <Button size="icon" variant="ghost" data-testid={`cat-delete-${c.slug}`} onClick={() => del(c)}><Trash2 className="h-4 w-4 text-red-600" /></Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
